function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.04 12.79L6.54 4.29C6.35 4.1 6.09 4 5.83 4C5.57 4 5.32 4.1 5.13 4.29L2.29 7.13C1.9 7.52 1.9 8.16 2.29 8.55L10.79 17.05C10.99 17.25 11.24 17.34 11.5 17.34C11.76 17.34 12.01 17.24 12.21 17.05L15.04 14.22C15.43 13.82 15.43 13.18 15.04 12.79V12.79ZM11.5 14.92L4.41 7.83L5.83 6.41L12.92 13.5L11.5 14.92V14.92ZM14.341 17.756L15.755 16.342L19.998 20.585L18.584 21.999L14.341 17.756ZM18.5 2C16.57 2 15 3.57 15 5.5C15 7.43 16.57 9 18.5 9C20.43 9 22 7.43 22 5.5C22 3.57 20.43 2 18.5 2ZM18.5 7C17.67 7 17 6.33 17 5.5C17 4.67 17.67 4 18.5 4C19.33 4 20 4.67 20 5.5C20 6.33 19.33 7 18.5 7Z",
  fill: "current"
});

function SvgCricket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCricket);
export default __webpack_public_path__ + "static/media/cricket.fa2a1ccd.svg";
export { ForwardRef as ReactComponent };